var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  /**
   * This file was auto-generated by Fern from our API Definition.
   */
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FlatfileEnvironment = void 0;
  exports.FlatfileEnvironment = {
    Production: "https://api.x.flatfile.com/v1"
  };
  return exports;
}